export const gameName = 'stairs';
export const socketGamePath = 'game';
